

























import { Component, Prop, Vue } from 'vue-property-decorator';
import moment from 'moment';
import { isLogin } from '@/global/utils';
import { validate } from '@/api/task/judge';

@Component
export default class JudgeDetailHeader extends Vue {
  @Prop() private task!: object;
  // 显示数据模型
  private taskSchema: any;
  private created() {
    this.taskSchema = this.getSchema(this.task);
  }
  // 获取快判任务数据模型
  private getSchema(data) {
    const judgeArr = [
      {
        label: '剩余题数',
        key: 'nums',
        value: data.nums || '0',
      },
      {
        label: '准确率要求',
        key: 'right_rate',
        value: data.right_rate ? data.right_rate + '%' : '-',
      },
      {
        label: '结束时间',
        key: 'end_time',
        value: moment(data.end_time || '').format('YYYY-MM-DD HH:mm:ss'),
      },
    ];
    const judgeSkills = [
      {
        label: '每题经验值',
        key: 'skills',
        value: data.skills[0].skill_exp,
      },
      {
        label: '任务类别',
        key: 'skills',
        value: data.skills
          .map((item, index) => item.skill_type_name)
          .toString(),
      },
    ];
    let judgeSchema;
    if (data.skills) {
      judgeSchema = judgeArr.concat(judgeSkills);
    } else {
      judgeSchema = judgeArr;
    }
    return judgeSchema;
  }
  // 做题
  private async handlerStartLib() {
    if (!isLogin(this)) {
      return;
    }
    const task: any = this.task;
    const res: any = await validate({ id: task.id });
    if (res.code === '200') {
      this.$router.push({
        name: 'lib',
        params: { id: task.id },
      });
    }
  }
  // 考核
  private async handlerStartCheck() {
    if (!isLogin(this)) {
      return;
    }
    const task: any = this.task;
    const res: any = await validate({ id: task.id });
    if (res.code === '200') {
      this.$router.push({
        name: 'judgecheck',
        params: { id: task.id, gid: task.gid },
      });
    }
  }
}
